
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';
import {useEvent} from "@hooks/useEvent"
import { addExtraSpace } from '../utils';

export const useDocument = ({ containerKey, addData, updateData, updateContact , deleteData})=>{
 const {isLoading,saveForm,deleteForm}=useEvent(containerKey)
 const dispatch = useDispatch();
  const addItem = useCallback(async(tableName,otherParams) => {
   try{
      const response=await saveForm({[`${tableName}`]:[otherParams || {id:""}]})
      if(response){
    const {role,...rest}=response
      dispatch(addData({
          data:rest,
          meta:{tableName}
      }))
    //  callback && callback(response)
      }
   }
   catch(e){

   }
    
  }, []);

  const deleteItem = useCallback(async(id,tableName,params={},clientSideOnly=false) => {
    try{
        if(clientSideOnly)
            dispatch(deleteData({id,meta:{tableName}}))
        
        else{ 
         const response=await deleteForm({[`${tableName}`]:[{id,...params}]})
          if(response)
            dispatch(deleteData({id,meta:{tableName}})) 
        }
      
     }
     catch(e){

     }
 }, []);

 const updateItem = useCallback((id,tableName,data) =>dispatch(updateData({id,data,meta:{tableName}})),[])
 
 const updateContactInfo = useCallback((id,tableName,data) =>dispatch(updateContact({id,data,meta:{tableName}})),[]);


 const saveItem = useCallback(async(tableName,payload,updateOtherFields={}) => {
    try{
        const response=await saveForm({[`${tableName}`]:[addExtraSpace(payload)],...addExtraSpace(updateOtherFields)},false)
    }
    catch{

    }
 }, [saveForm]);

 const onSelect=useCallback(async(id,tableName,payload,updateOtherFields) => {
    try{
        updateItem(id,tableName,addExtraSpace(payload,true))
        const response=await saveItem(tableName,payload,updateOtherFields)
    }
    catch{

    }
 }, [saveForm,updateItem]);

  return {isLoading,addItem,deleteItem,updateItem,saveItem,onSelect,updateContactInfo}
}